import React, { useCallback, useRef } from 'react';
import Text from '@goodfynd/react-web.typography.text';
import {
    FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup
} from '@mui/material';

import type { InputRadioGroupControlProps } from '../types';

import { StyledLabel } from './styles';
export default React.forwardRef(function InputRadioGroupControl<T = string>(
  {
    defaultValue,
    error,
    label,
    onChange,
    options,
    showLabel = true,
    value,
  }: Omit<InputRadioGroupControlProps<T>, 'control'>,
  ref: any
) {
  const selectedOption = useRef(defaultValue || null);
  const renderOptions = useCallback(() => {
    return options.map((option) => (
      <FormControlLabel
        control={<Radio />}
        key={typeof option.label === 'string' ? option.label : option.value}
        value={option.value}
        label={
          <StyledLabel>
            <Text type="body1">{option.label}</Text>
            <Text>{option.labelRight}</Text>
          </StyledLabel>
        }
      />
    ));
  }, [options]);

  // defaultValue && alert(defaultValue);
  return (
    <FormControl error={!!error} fullWidth variant="outlined">
      {showLabel &&
        (typeof label === 'string' ? (
          <FormLabel component="legend">{label}</FormLabel>
        ) : (
          label
        ))}

      <RadioGroup
        defaultValue={(ref ?? selectedOption)?.current}
        onChange={onChange}
        value={value}
      >
        {renderOptions()}
      </RadioGroup>
      <FormHelperText>{error?.message}</FormHelperText>
    </FormControl>
  );
});
